import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row h-100" }
const _hoisted_2 = { class: "col-sm-12 my-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mx-auto" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center",
      style: {"{\r\n\t\t\t\t\t\t\t\t\t\t\theight":"120px","width":"120px"}
    }, [
      /*#__PURE__*/_createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.0",
        width: "120.000000pt",
        height: "120.000000pt",
        viewBox: "0 0 512.000000 512.000000",
        preserveAspectRatio: "xMidYMid meet"
      }, [
        /*#__PURE__*/_createElementVNode("g", {
          transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
          fill: "#f2645a",
          stroke: "none"
        }, [
          /*#__PURE__*/_createElementVNode("path", {
            d: "M134 5110 c-68 -21 -134 -114 -134 -190 0 -81 8 -91 361 -445 186 -187 339 -344 339 -347 0 -4 -43 -36 -95 -73 -150 -104 -309 -239 -451 -380 -112 -112 -133 -137 -144 -178 -23 -86 6 -168 79 -221 38 -27 51 -31 109 -31 83 0 93 6 268 175 72 70 180 165 240 211 112 87 252 185 280 196 11 4 93 -71 290 -268 l273 -273 -117 -61 c-203 -105 -375 -226 -570 -403 -103 -95 -138 -157 -129 -234 11 -93 78 -162 168 -174 78 -11 119 8 221 103 213 197 436 343 668 437 l64 26 318 -317 c337 -336 332 -331 246 -332 -153 -3 -442 -110 -629 -234 -181 -119 -279 -230 -279 -316 0 -56 43 -134 93 -167 36 -24 52 -29 109 -29 73 0 76 1 215 116 144 119 334 204 516 230 156 23 366 -16 529 -97 43 -21 227 -199 948 -919 821 -819 899 -894 940 -905 158 -42 292 92 250 250 -11 42 -187 221 -2388 2423 -1307 1308 -2393 2389 -2413 2403 -41 28 -124 40 -175 24z",
            fill: "#f2645a"
          }),
          /*#__PURE__*/_createElementVNode("path", {
            d: "M2290 4660 c-261 -25 -509 -71 -561 -105 -49 -32 -79 -84 -86 -147 -4 -45 -1 -61 24 -108 23 -44 39 -60 83 -83 63 -33 66 -33 290 6 630 111 1288 18 1850 -263 304 -151 530 -311 770 -545 167 -162 178 -170 262 -170 58 0 71 4 109 31 73 53 102 135 79 221 -11 42 -31 66 -149 183 -550 545 -1225 871 -1996 966 -153 18 -540 26 -675 14z",
            fill: "#f2645a"
          }),
          /*#__PURE__*/_createElementVNode("path", {
            d: "M2865 3454 c-132 -68 -153 -233 -42 -331 28 -25 57 -36 149 -57 410 -96 719 -263 1041 -563 85 -80 130 -99 207 -89 89 12 156 82 167 174 8 75 -20 128 -119 222 -340 320 -754 544 -1185 639 -111 25 -177 26 -218 5z",
            fill: "#f2645a"
          }),
          /*#__PURE__*/_createElementVNode("path", {
            d: "M2460 1106 c-119 -33 -205 -128 -231 -253 -47 -227 157 -431 383 -384 137 28 231 122 259 259 49 238 -174 443 -411 378z",
            fill: "#f2645a"
          })
        ])
      ])
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Recargar")

import { ref, onMounted, onUnmounted } from "vue";
import { coreApi } from "@/conection";
import { AuthModule } from "@/store/modules/Auth";
import { date } from "yup";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const drawer = ref(false);
onMounted(() => {
	window.addEventListener("offline", () => {
		drawer.value = true;
		const offEvents = JSON.parse(localStorage.getItem("offlineEvents") || "[]");
		offEvents.push({ date: new Date() });
		localStorage.setItem("offlineEvents", JSON.stringify(offEvents));
	});
	window.addEventListener("online", () => {
		drawer.value = false;
		const offEvents = JSON.parse(localStorage.getItem("offlineEvents") || "[]");
		localStorage.setItem("offlineEvents", "[]");

		coreApi.post("/api/log", {
			event: "Online mode",
			userID: AuthModule.user?.id,
			userName: AuthModule.user?.name,
			offEvents: offEvents,
			onlineEvent: new Date(),
		});
	});
});
onUnmounted(() => {
	window.removeEventListener("offline", () => (drawer.value = true));
	window.removeEventListener("online", () => (drawer.value = false));
});
const reloadPage = () => {
	window.location.reload();
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_result = _resolveComponent("el-result")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: drawer.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawer).value = $event)),
    title: "I am the title",
    "with-header": false,
    size: "100%",
    direction: "ttb"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_result, {
            title: "Fuera de linea ",
            "sub-title": "Usted se encuentra fuera de linea, intentelo mas tarde"
          }, {
            icon: _withCtx(() => [
              _hoisted_3
            ]),
            extra: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "danger",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (reloadPage()))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})